const FALLBACK_ERROR_MESSAGE = "Something went wrong. Please try again.";

/**
 * Reads a user-facing message from an Axios error body.
 * Callers should prefer error.userMessage after the apiClient interceptor
 * or auth.public has already attached it.
 */
export async function extractApiMessage(error, fallback = FALLBACK_ERROR_MESSAGE) {
  const data = error?.response?.data;
  if (!data) {
    return fallback;
  }
  if (typeof data === "string" && data.trim()) {
    return data;
  }
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      const text = await data.text();
      try {
        const parsed = JSON.parse(text);
        if (typeof parsed?.message === "string" && parsed.message.trim()) {
          return parsed.message;
        }
      } catch {
        if (text.trim()) {
          return text;
        }
      }
    } catch {
      return fallback;
    }
    return fallback;
  }
  if (typeof data.message === "string" && data.message.trim()) {
    return data.message;
  }
  return fallback;
}

export async function appendApiMessage(error, fallback) {
  if (error && !error.userMessage) {
    error.userMessage = await extractApiMessage(error, fallback);
  }
  return error;
}
